export const tr = {
    error: 'Hatalı',
    new: 'Yeni',
    processing: 'İşleniyor',
    ready: 'Hazır'
};
